import { useProductsStore } from "@multicines/stores";
import { showLoyaltySnack } from "@multicines/utils";
import { getLoyaltySnackQtyAvailable } from "@multicines/utils";
import { getProductTotals } from "artisn/products";
import PlusSVG from "images/plus.svg";
import Image from "next/image";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { responsive } from "./SnackSlider.helpers";
import SnackSliderPlaceholder from "./SnackSlider.placeholder";
import Styles, { ImageEmpty, Info, Product } from "./SnackSlider.styles";
import { SnackSliderProps as Props } from "./SnackSlider.types";
import Button from "../Button/Button";
import ErrorState from "../ErrorState/ErrorState";
import useUtils from "hooks/useUtils";

import "swiper/css";

const SnackSlider: React.FC<Props> = props => {
  const { status, products, onPressSnack, discounts } = props;
  const { errorTitle, errorDescription, onPressError } = props;
  const snackRestrictionCard = useProductsStore(
    store => store.snackRestrictionCard
  );
  const { formatByCurrency } = useUtils();

  return (
    <Styles className="SnackSlider">
      {status === "idle" || status === "loading" ? (
        <SnackSliderPlaceholder numberProducts={2} />
      ) : null}
      {status === "error" ? (
        <ErrorState
          title={errorTitle ?? ""}
          description={errorDescription ?? ""}
          onClick={onPressError}
        />
      ) : null}
      {status === "success" ? (
        <Swiper breakpoints={responsive}>
          {products?.map(product => {
            const { productId, name, images } = product;
            const [image] = images ?? [];
            const { url } = image ?? {};
            const { netPrice } = getProductTotals(product, 1);
            const formattedPrice = formatByCurrency(netPrice);

            const { additionalInfo } = product ?? {};
            const { specialTicketType } = additionalInfo ?? {};

            //TODO: document this logic
            if (
              snackRestrictionCard !== undefined &&
              specialTicketType !== undefined
            ) {
              return null;
            }

            const showCounter = showLoyaltySnack(product);
            const qtyAvailable = getLoyaltySnackQtyAvailable(
              product,
              discounts
            );

            return (
              <SwiperSlide key={productId}>
                <Product>
                  {url ? (
                    <Image
                      src={url}
                      alt={name}
                      width={180}
                      height={180}
                      objectFit="cover"
                    />
                  ) : (
                    <ImageEmpty />
                  )}
                  <Info className="Info">
                    <p className="Info__text">{name}</p>
                    <p className="Info__text Info__text--price">
                      {formattedPrice}
                    </p>
                    {showCounter ? (
                      <p className="Info__text">{`Disponible: ${qtyAvailable}`}</p>
                    ) : null}
                  </Info>
                  <Button
                    onClick={() => onPressSnack(product)}
                    className="SnackSlider__button"
                  >
                    <PlusSVG className="SnackSlider__icon" />
                  </Button>
                </Product>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : null}
    </Styles>
  );
};

export default SnackSlider;
